import { FlowTemplatesListComponent } from "../components/Pages/Templates/List";
import { LayoutHeader2 } from "../components/Interactions/LayoutHeader2";

export const FlowTemplatesPage: React.FC = () => {
  return (
    <LayoutHeader2>
      <FlowTemplatesListComponent />
    </LayoutHeader2>
  );
};
